import { render, staticRenderFns } from "./CategoryCustom.vue?vue&type=template&id=cbc7679e&scoped=true"
import script from "./CategoryCustom.vue?vue&type=script&lang=js"
export * from "./CategoryCustom.vue?vue&type=script&lang=js"
import style0 from "./CategoryCustom.vue?vue&type=style&index=0&id=cbc7679e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc7679e",
  null
  
)

export default component.exports